import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=c925420e&scoped=true"
import script from "./appFooter.js?vue&type=script&lang=js&external"
export * from "./appFooter.js?vue&type=script&lang=js&external"
import style0 from "./appFooter.vue?vue&type=style&index=0&id=c925420e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c925420e",
  null
  
)

export default component.exports